module.exports = __webpack_public_path__ + "img/copper14.fbd80502.gif";